import { render, staticRenderFns } from "./ManageBoardModal.vue?vue&type=template&id=5d1a9617&scoped=true"
import script from "./ManageBoardModal.vue?vue&type=script&lang=js"
export * from "./ManageBoardModal.vue?vue&type=script&lang=js"
import style0 from "./ManageBoardModal.vue?vue&type=style&index=0&id=5d1a9617&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1a9617",
  null
  
)

export default component.exports